//? PLUGINS //
import { Box, Card } from "@mui/material";
import { BoxProps } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";

//? STYLES //
import * as Styles from "styles/pages/error.styles";

const UnauthorizedPage = () => {
  const { t } = useTranslation();

  const titleBox: BoxProps = {
    component: "h1",
    sx: Styles.Title,
  };
  const subTitleBox: BoxProps = {
    component: "h4",
    sx: Styles.Subtitle,
  };

  return (
    <Box sx={Styles.Container}>
      <Card sx={Styles.Card}>
        <Box>
          <Box {...titleBox}>{t("errors.unauthorizedTitle")}</Box>
          <Box sx={Styles.TextContainer}>
            <Box sx={Styles.Text}>4 0 3</Box>
          </Box>
          <Box {...subTitleBox}>
            {t("errors.unauthorized")}
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default UnauthorizedPage;
